<script setup>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '../stores/userStore'
import axios from '../axios'

const router = useRouter()
const userStore = useUserStore()

const activeTab = ref('admin')

const defaultCredentials = {

}


const credentials = ref({
  email: defaultCredentials[activeTab.value]?.email,
  password: ''
})

watch(activeTab, (newTab) => {
  credentials.value.email = defaultCredentials[newTab]?.email
  credentials.value.password = ''
  error.value = ''
})

const error = ref('')
const loading = ref(false)

const login = async () => {
  loading.value = true
  error.value = ''
  
  try {
    // No need for CSRF cookie with Bearer token authentication
    
    // Use the store's login action
    await userStore.login({
      email: credentials.value.email,
      password: credentials.value.password,
      role: activeTab.value
    })

    // Redirect to home page
    router.push('/')
  } catch (err) {
    console.error('Full error:', err)
    error.value = err.message || 'Login failed'
  } finally {
    loading.value = false
  }
} 
</script>

<template>
  <div class="min-h-screen bg-gradient-to-br from-pink-50 via-white to-pink-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="flex justify-center">
        <img src="/OC_print_logo_icon_color.svg" alt="OddsComposer Logo" class="h-16 w-auto transform hover:scale-105 transition-transform duration-300">
      </div>
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
        Welcome Back
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        Sign in to your OddsComposer account
      </p>
      <!-- <div class="mt-4 flex justify-center space-x-1 bg-gray-100 p-1 rounded-lg max-w-xs mx-auto">
        <button
          @click="activeTab = 'admin'"
          class="flex-1 py-2 px-4 text-sm font-medium rounded-md transition-colors duration-200"
          :class="activeTab === 'admin' 
            ? 'bg-white text-gray-900 shadow-sm' 
            : 'text-gray-500 hover:text-gray-700'"
        >
          <i class="fas fa-user-shield mr-2"></i>
          Admin
        </button>
        <button
          @click="activeTab = 'client'"
          class="flex-1 py-2 px-4 text-sm font-medium rounded-md transition-colors duration-200"
          :class="activeTab === 'client' 
            ? 'bg-white text-gray-900 shadow-sm' 
            : 'text-gray-500 hover:text-gray-700'"
        >
          <i class="fas fa-user mr-2"></i>
          Client
        </button>
      </div> -->
      <!-- <div class="mt-2 text-center text-xs text-gray-500 bg-gray-50 rounded-full px-3 py-1 inline-block">
        Demo: {{ defaultCredentials[activeTab].email }} / {{ defaultCredentials[activeTab].password }}
      </div> -->
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow-2xl sm:rounded-2xl sm:px-10 border border-gray-100">
        <form class="space-y-6" @submit.prevent="login">
          <div v-if="error" 
            class="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg flex items-center space-x-3"
          >
            <div class="flex-shrink-0">
              <i class="fas fa-exclamation-circle text-red-400"></i>
            </div>
            <p class="text-sm text-red-700">{{ error }}</p>
          </div>

          <div>
            <label for="email" class="block text-sm font-medium text-gray-700">
              Email address
            </label>
            <div class="mt-1 relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <i class="fas fa-envelope text-gray-400"></i>
              </div>
              <input
                id="email"
                v-model="credentials.email"
                type="email"
                required
                class="appearance-none block w-full pl-10 px-3 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500"
                placeholder="Enter your email"
              >
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">
              Password
            </label>
            <div class="mt-1 relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <i class="fas fa-lock text-gray-400"></i>
              </div>
              <input
                id="password"
                v-model="credentials.password"
                type="password"
                required
                class="appearance-none block w-full pl-10 px-3 py-2 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500"
                placeholder="Enter your password"
              >
            </div>
          </div>

          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <input
                id="remember-me"
                type="checkbox"
                class="h-4 w-4 text-pink-600 focus:ring-pink-500 border-gray-300 rounded"
              >
              <label for="remember-me" class="ml-2 block text-sm text-gray-700">
                Remember me
              </label>
            </div>

            <div class="text-sm">
              <a href="#" class="font-medium text-pink-600 hover:text-pink-500 transition-colors">
                Forgot password?
              </a>
            </div>
          </div>

          <div>
            <button
              type="submit"
              :disabled="loading"
              class="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-pink-600 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              <span v-if="loading" class="flex items-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Signing in...
              </span>
              <span v-else>Sign in</span>
            </button>
          </div>
        </form>

        <div class="mt-6">
          <div class="relative">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-200"></div>
            </div>
            <div class="relative flex justify-center text-sm">
              <span class="px-2 bg-white text-gray-500">
                Need help?
              </span>
            </div>
          </div>

          <div class="mt-6 grid grid-cols-1 gap-3">

            <a href="#" class="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-lg shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 transition-colors">
              <i class="fas fa-headset mr-2"></i>
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-gradient-to-br {
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style> 